var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("账单管理")]),
              _c("el-breadcrumb-item", [_vm._v("驻场人力")])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-radio-group",
            {
              staticStyle: { "margin-bottom": "20px" },
              model: {
                value: _vm.tabPosition,
                callback: function($$v) {
                  _vm.tabPosition = $$v
                },
                expression: "tabPosition"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: "1" } }, [
                _vm._v("腾讯固定HC")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "开始时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                placeholder: "选择日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.searchForm.startTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "startTime", $$v)
                                },
                                expression: "searchForm.startTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "结束时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                placeholder: "选择日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.searchForm.endTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "endTime", $$v)
                                },
                                expression: "searchForm.endTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "search-button", attrs: { span: 12 } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleSearch }
                          },
                          [_vm._v("点击查询")]
                        ),
                        _c("el-button", { on: { click: _vm.handleReset } }, [
                          _vm._v("重置")
                        ]),
                        _c(
                          "el-button",
                          { on: { click: _vm.debouncedExport } },
                          [_vm._v(_vm._s(_vm.exportButtonText))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("固定HC账单列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "margin-bottom": "20px",
                  "font-size": "14px"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "margin-right": "8px"
                    }
                  },
                  [_vm._v("驻场人力总计（人月）：")]
                ),
                _c("span", { staticStyle: { color: "#333" } }, [
                  _vm._v(_vm._s(_vm.totalManpower))
                ])
              ]
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.tableData, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" }
                }),
                _c("el-table-column", {
                  attrs: { type: "index", label: "序号", width: "80" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "region", label: "区域-地区" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "position", label: "计费岗位" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "unit", label: "计费单位" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "amount", label: "计费数量" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "startTime", label: "开始时间" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "endTime", label: "结束时间" }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }